import { useCachedQuery } from '../../../../hooks/useCachedQuery';

// Protocolos estéticos do paciente, com cache de leitura offline (via useCachedQuery).
export function useAestheticProtocols(patientId) {
  const url = patientId ? `/patients/${patientId}/aesthetic-protocols` : null;

  const { data, isLoading, isStale, updatedAt, error, refetch } = useCachedQuery(url);

  return {
    protocols: data ?? [],
    isLoading,
    isStale,
    updatedAt,
    error,
    refetch,
  };
}
